import { Component, Input, HostListener, OnDestroy } from "@angular/core";
import { MatDrawer } from "@angular/material/sidenav";
import { SitefinityPortalMenu, ADPResourceService as ResourceService } from "digital-core";

@Component({
  selector: "portal-menu-wrapper",
  templateUrl: "./portal-menu-wrapper.component.html",
  styleUrls: ["./portal-menu-wrapper.component.css"]
})
export class PortalMenuWrapperComponent implements OnDestroy {
  @Input() menus: SitefinityPortalMenu;
  @Input() sidenav: MatDrawer;
  @Input() menuKey: string;
 
  get resource() {
    return this.resourceService;
  }

  constructor(private resourceService: ResourceService) { }
  ngOnDestroy(): void {
    this.sidenav.close();
  }

  @HostListener('click', ['$event'])
  whenClicked(event: any) {
      this.sidenav.close();
  }
}
